import React from "react";

// Elements d'estètica scrapbook / àlbum de viatges

export const WashiTape = ({ className = "", variant = "sage" }) => {
  const v = { terra: "washi-terra", forest: "washi-forest", cream: "washi-cream" }[variant] || "";
  return <span className={`washi-tape ${v} ${className}`} aria-hidden="true" />;
};

// Segell de viatge (postmark) escrit a mà
export const Postmark = ({ children, className = "", rotate = -6 }) => (
  <span
    className={`inline-flex items-center gap-1 rounded-md border-[2.5px] border-dashed px-3 py-1 font-hand text-lg font-bold leading-none ${className}`}
    style={{ transform: `rotate(${rotate}deg)` }}
  >
    {children}
  </span>
);

// Xinxeta / pin de cartolina
export const Pin = ({ className = "" }) => (
  <span className={`block h-4 w-4 rounded-full bg-terracotta ${className}`} style={{ boxShadow: "inset -2px -2px 3px rgba(0,0,0,0.25), 0 3px 5px -1px rgba(44,76,59,0.4)" }} aria-hidden="true" />
);
